import { classes } from "./react"

type DialogBodyProps = {
    className?: string
    /**
     * Whether the modal content should include padding.
     *
     * @default true
     */
    padding?: boolean
}

export const DialogBody: React.FunctionComponent<React.PropsWithChildren<DialogBodyProps>> = ({
    children,
    className,
    padding = true,
}) => (
    <div className={classes("modal-body material-form", { "modal-body--no-padding": !padding }, className)}>
        {children}
    </div>
)
